import { Button } from "@/components/ui/button";
import { UploadIcon } from "lucide-react";
import { useNavigate } from "react-router";
import { cn } from "@/lib/utils";

interface ImportButtonProps {
  context: string;
  size?: "sm" | "md" | "lg";
  className?: string;
  variant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link";
  showLabel?: boolean;
}

export const ImportButton = ({
  context,
  size = "md",
  className = "",
  variant = "default",
  showLabel = true,
}: ImportButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/app/imports?type=${context}`);
  };

  const sizeClasses = {
    sm: "h-8 px-3",
    md: "h-10 px-4",
    lg: "h-12 px-6",
  };

  return (
    <Button
      onClick={handleClick}
      className={cn("flex items-center gap-2", sizeClasses[size], className)}
      variant={variant}
    >
      <UploadIcon size={size === "sm" ? 16 : size === "lg" ? 22 : 20} />
      {showLabel && (
        <span
          className={cn(size === "sm" ? "text-xs" : "text-sm", "font-semibold")}
        >
          Import {context}
        </span>
      )}
    </Button>
  );
};
